const IlotD_synthese_18 = require('./IlotD_synthese_18.webp');
export default [IlotD_synthese_18];
